import { render, staticRenderFns } from "./StatisticsAnalysisPage.vue?vue&type=template&id=7956fa22&scoped=true&"
import script from "./StatisticsAnalysisPage.vue?vue&type=script&lang=js&"
export * from "./StatisticsAnalysisPage.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsAnalysisPage.vue?vue&type=style&index=0&id=7956fa22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7956fa22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
